export const iconFontAwesomeEditingCircleCheck = (
	<i className="fa-solid fa-circle-check"></i>
);
